import request from '@/utils/request'

// 新增跟进
export function createFollow(data) {
  return request({
    url: '/crmFollow/create',
    method: 'post',
    data: data
  })
}

export function queryAtList(query) {
  return request({
    url: '/crmFollow/queryAtList',
    method: 'get',
    params: query
  })
}

// 分页查询某个业务实体的跟进列表
export function listFollowByTarget(data) {
  return request({
    url: '/crmFollow/listByTarget',
    method: 'post',
    data: data
  })
}

// 分页查询所有跟进列表
export function listFollow(data) {
  return request({
    url: '/crmFollow/list',
    method: 'post',
    data: data
  })
}

// 回复跟进
export function createFollowReply(param) {
  return request({
    url: '/crmFollow/createFollowReply',
    method: 'post',
    data: param
  })
}

// 查询跟进回复列表
export function queryFollowReplyList(data) {
  return request({
    url: '/crmFollow/queryFollowReplyList',
    method: 'post',
    data: data
  })
}

export function deleteFollowReply(param) {
  return request({
    url: '/crmFollow/deleteFollowReply',
    method: 'post',
    data: param
  })
}
